<template>
  <div class="page-wrapper py-4">
    <div id="master" ref="master" class="master" @scroll="handleScroll">
      <menutop :menu/>
      <TiendaEnLineaNew id="page1" bg="white" class="section" />
      <ClientesInviertenNew id="page2" bg="black" class="section" />
      <SinComisionesNew id="page3" bg="white" class="section" />
      <!-- <page4 id="page4" bg="black" class="section" /> -->
      <GestionMenusNew id="page4" bg="white" class="section" />
      <TituloPlataformaNew id="page5" bg="black" class="section" />
      <AppMovilNew id="page6" bg="white" class="section" />
      <PedidosPlataformaNew id="page7" bg="white" class="section" />
      <CallCenterNew id="page8" bg="white" class="section" />
      <PasarelasPagosNew id="page9" bg="white" class="section" />
      <BeneficiosClaveNew id="page10" bg="black" class="section" />
      <TestimonioOrderNew id="page11" bg="white" class="section" />
      <CallToActionOrderNew id="page12" bg="white" class="section" />
      <FooterOrderNew id="page13" bg="black" class="section" />
      

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import menutop from '@/components/structure/menutop.vue'
import TiendaEnLineaNew from '@/components/pages/order/TiendaEnLineaNew.vue'
import ClientesInviertenNew from '@/components/pages/order/ClientesInviertenNew.vue'
import SinComisionesNew from '@/components/pages/order/SinComisionesNew.vue'
// import page4 from '@/components/pages/order/page4.vue'
import BeneficiosClaveNew from '@/components/pages/order/BeneficiosClaveNew.vue'
import GestionMenusNew from '@/components/pages/order/GestionMenusNew.vue'
import TituloPlataformaNew from '@/components/pages/order/TituloPlataformaNew.vue'
import AppMovilNew from '@/components/pages/order/AppMovilNew.vue'
import PedidosPlataformaNew from '@/components/pages/order/PedidosPlataformaNew.vue'
import TestimonioOrderNew from '@/components/pages/order/TestimonioOrderNew.vue'
import CallToActionOrderNew from '@/components/pages/order/CallToActionOrderNew.vue'
import FooterOrderNew from '@/components/pages/order/FooterOrderNew.vue'
import CallCenterNew from '@/components/pages/order/CallCenterNew.vue'
import PasarelasPagosNew from '@/components/pages/order/PasarelasPagosNew.vue'

export default {
  name: 'orderView',
  props:{
      con: {
          default: {},
          type: Object
      }
  },
  components: {
    menutop,
    TiendaEnLineaNew,
    ClientesInviertenNew,
    SinComisionesNew,
    // page4,

    GestionMenusNew,
    TituloPlataformaNew,
    AppMovilNew,
    PedidosPlataformaNew,
    CallCenterNew,
    PasarelasPagosNew,
    BeneficiosClaveNew,
    TestimonioOrderNew,
    CallToActionOrderNew,
    FooterOrderNew
    
   
  },
  watch: {
    currentSection() {
      if(document.getElementById(`page${this.currentSection}`)) {
        console.log(document.getElementById(`page${this.currentSection}`).getAttribute('bg'), this.currentSection);
        this.menu = document.getElementById(`page${this.currentSection}`).getAttribute('bg');
      }
    }
  },
  data() {
    return {
      menu: 'white',
      currentSection: 1,
    };
  },
  methods: {
    handleScroll() {
      const scrollPosition = this.$refs.master.scrollTop;
      const windowHeight = window.innerHeight;
      const menuHeight = 80; // Altura del menutop
      const adjustedScrollPosition = scrollPosition + menuHeight;
      const section = Math.floor(adjustedScrollPosition  / windowHeight) + 1;
      if (section < 1) {
        this.currentSection = 1;
      } else if (section > 11) {
        this.currentSection = 11;
      } else {
        this.currentSection = section;
      }
    },
 
  },
}
</script>

<style lang="css">
.page-wrapper {
  background-color: #F0EFEB; /* background color */
  width: 100%;
  height: 96vh;
  display: flex;
  justify-content: center; /* centra .master horizontalmente */
  align-items: center;     /* centra .master verticalmente */
  box-sizing: border-box;
}

.master {
  margin-top: 16px !important;
  position: relative;
  background-color: #fff;
  border-radius: 16px;
  width: 97.95vw !important;
  height: 95.5vh !important;
  max-width: none;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);

  /* Firefox */
  scrollbar-width: none !important;
  /* IE 10+ */
  -ms-overflow-style: none !important;
}

/* Chrome, Safari, Opera */
.master::-webkit-scrollbar {
  display: none !important;
}

@media (max-width: 992px) {
  .master {
      padding-top: 0px !important;
  }
}
</style>